"use strict";
/**
 * Studio Apps API Core Domain Objects.
 * Shared types Manifold Studio Client App Bridge.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=domain.js.map